import type { AppIconInput } from "./appIcon";
import type { FriendlyAppNameInput } from "./friendlyAppName";
import { useFriendlyAppName } from "./useFriendlyAppName";

type AppFriendlyNameProps = FriendlyAppNameInput &
  AppIconInput & {
    className?: string;
  };

/** Renders the App Store–aware friendly app name for a row or label. */
export function AppFriendlyName({
  className,
  displayName,
  appIdentifier,
  category,
}: AppFriendlyNameProps) {
  const name = useFriendlyAppName({ displayName, appIdentifier, category });
  return <span className={className}>{name}</span>;
}
